"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var seedrandom_1 = __importDefault(require("seedrandom"));
var util_1 = require("./util");
exports.initRand = function (seed) {
    if (seed === void 0) { seed = null; }
    return util_1.isDefined(seed) ? seedrandom_1.default(seed, { global: true }) : Math.random;
};
exports.range = function (min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
};
exports.sample = function (xs) { return xs[Math.floor(Math.random() * xs.length)]; };
